import clsx from 'clsx'
import { useRouter } from 'next/router'

import { Button } from '@wartek-id/button-v1'
import { historyUtils } from '@wartek-id/fe-toolbox'
import {
  HeaderBar,
  HeaderBarLeftAction,
  HeaderBarRightAction,
  HeaderBarTitle,
} from '@wartek-id/header-bar'
import { Icon } from '@wartek-id/icon'

interface PemetaanKompetensiPageHeaderProps {
  title: string
  icon?: string
  subtitle?: string
  rightActionLabel?: string
  withoutShadow?: boolean
  rightActionFunction?: Function
  leftActionFunction?: Function
  className?: string
  hideRightAction?: boolean
}

const PageHeader = ({
  title,
  icon = 'arrow_back',
  subtitle = '',
  rightActionLabel = '',
  rightActionFunction,
  leftActionFunction,
  withoutShadow = false,
  className = '',
  hideRightAction = false,
}: PemetaanKompetensiPageHeaderProps) => {
  const router = useRouter()

  return (
    <HeaderBar
      fixed
      className={clsx(
        'z-10 header-ujikom',
        withoutShadow && '!shadow-none',
        className
      )}
    >
      <HeaderBarLeftAction
        icon={
          <Icon as="i" color="default">
            {icon}
          </Icon>
        }
        onClick={
          leftActionFunction
            ? () => leftActionFunction()
            : () => historyUtils.backToApp(() => router.back())
        }
      />
      <HeaderBarTitle subtitle={subtitle}>{title}</HeaderBarTitle>
      {!hideRightAction && !!rightActionLabel && (
        <HeaderBarRightAction
          type="text"
          className="one-line-action cursor-pointer"
          onClick={() => rightActionFunction()}
        >
          {rightActionLabel}
        </HeaderBarRightAction>
      )}

      {!hideRightAction && !rightActionLabel && (
        <HeaderBarRightAction>
          <Button
            iconOnly
            size="md"
            variant="ghost"
            className="!h-9 !w-9"
            onClick={() => {
              window.open(
                'https://pusatinformasi.guru.kemdikbud.go.id/hc/en-us/sections/16600161423257-Uji-Kompetensi-Pelaksana-Guru',
                '_blank'
              )
            }}
          >
            <Icon as="i" color="inherit">
              info_outlined
            </Icon>
          </Button>
        </HeaderBarRightAction>
      )}
    </HeaderBar>
  )
}

export default PageHeader
